import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Login",
        component: Login,
    },
    {
        path: "/Index",
        name: "Index",
        component: () => import("../views/Index.vue"),
        meta: {
            title: "首页",
        },
    },
    {
        path: "/Vendor",
        name: "Vendor",
        component: () => import("../views/Vendor.vue"),
        meta: {
            title: "首页",
        },
    },
    {
        path: "/pdf",
        name: "Pdf",
        component: () => import("../views/pdf.vue"),
        meta: {
            title: "首页",
        },
    },
    {
        path: "/details",
        name: "Details",
        component: () => import("../views/Details.vue"),
        meta: {
            title: "首页",
        },
    },
];

const router = new VueRouter({
    routes,
});
export default router;
